import React, { SVGAttributes } from 'react';

export const AppleWalletIcon = (props: SVGAttributes<unknown>): JSX.Element => (
  <svg viewBox='0 0 198.44 149' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' {...props}>
    <defs>
      <linearGradient id='wallet-grad-1' x1='-53.58' y1='120.72' x2='-53.58' y2='114.42' gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#cbc9be' stopOpacity='1' />
        <stop offset='1' stopColor='#c8c5bb' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='wallet-grad-2'
        x1='-53.58'
        y1='120.72'
        x2='-53.58'
        y2='114.42'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(190.18)'
      >
        <stop offset='0' stopColor='#cbc9be' stopOpacity='1' />
        <stop offset='1' stopColor='#c8c5bb' stopOpacity='0' />
      </linearGradient>
    </defs>
    <g transform='translate(53.58,-46.34)'>
      <g>
        {/* Background card */}
        <path
          transform='matrix(0.26458,0,0,0.26458,-53.77,0.24)'
          d='M 77.74,174.23 C 27.24,174.23 0.72,205.05 0.72,251.26 v 409.11 c 0,46.21 26.52,77.02 77.02,77.02 H 673.69 c 50.5,0 77.02,-30.82 77.02,-77.02 V 251.26 c 0,-46.21 -26.52,-77.02 -77.02,-77.02 z'
          fill='#d9d6cc'
        />
        {/* Red card with wavy bottom */}
        <path
          d='m -31.59,54.7 c -10.58,0 -13.73,6.34 -13.73,14.21 v 51.81 l 46.67,0.09 c 12.47,0.02 17.58,5.04 22.77,12.06 1.32,1.79 2.93,4.21 4.51,5.78 4.69,4.7 10.85,7.05 17.01,7.05 6.16,0 12.31,-2.35 17.01,-7.05 1.57,-1.57 3.18,-3.99 4.5,-5.78 5.2,-7.02 10.3,-12.04 22.77,-12.06 l 46.67,-0.09 V 68.91 c 0,-7.87 -3.15,-14.21 -13.73,-14.21 z'
          fill='#f16d5e'
        />
        {/* Blue card layer */}
        <path
          transform='matrix(0.26458,0,0,0.26458,-53.77,0.24)'
          d='m 83.82,205.81 c -39.97,0 -51.88,23.96 -51.88,53.71 v 62.74 c 0,-29.76 11.9,-53.71 51.88,-53.71 H 667.61 c 39.97,0 51.88,23.95 51.88,53.71 v -62.74 c 0,-29.75 -11.91,-53.71 -51.88,-53.71 z'
          fill='#3295c9'
        />
        {/* Orange/Yellow card layer */}
        <path
          d='m -31.59,71.3 c -10.58,0 -13.73,6.34 -13.73,14.21 v 16.6 c 0,-7.87 3.15,-14.21 13.73,-14.21 H 122.87 c 10.58,0 13.73,6.34 13.73,14.21 V 85.51 c 0,-7.87 -3.15,-14.21 -13.73,-14.21 z'
          fill='#fcad00'
        />
        {/* Green card layer */}
        <path
          d='m -31.59,87.9 c -10.58,0 -13.73,6.34 -13.73,14.21 v 16.6 c 0,-7.87 3.15,-14.21 13.73,-14.21 H 122.87 c 10.58,0 13.73,6.34 13.73,14.21 v -16.6 c 0,-7.87 -3.15,-14.21 -13.73,-14.21 z'
          fill='#50be3d'
        />
        {/* Left tab */}
        <rect x='-53.58' y='108.56' width='8.26' height='12.16' fill='url(#wallet-grad-1)' />
        {/* Right tab */}
        <rect x='136.59' y='108.56' width='8.26' height='12.16' fill='url(#wallet-grad-2)' />
      </g>
    </g>
  </svg>
);
